export const CEDEFI_ROUNDS = {
  LATEST_ROUND: 9,
  ALL_ROUNDS: [1, 2, 3, 4, 5, 6, 7, 8, 9],
  ROUND_NAMES: {
    1: '1st Round',
    2: '2nd Round',
    3: '3rd Round',
    4: '4th Round',
    5: '5th Round',
    6: '6th Round',
    7: '7th Round',
    8: '8th Round',
    9: '9th Round'
  },
  ROUND_TIMES: {
    6: {
      snapshotTime: 'July 31, 8PM SGT',
      claimingPeriod: 'July 31, 8PM SGT - August 30, 8PM SGT'
    },
    7: {
      snapshotTime: 'Aug 18 8PM SGT',
      claimingPeriod: 'Aug 19, 8PM SGT - Sep 19, 8PM SGT'
    },
    8: {
      snapshotTime: 'Nov 16 8PM SGT',
      claimingPeriod: 'Nov 18, 8PM SGT - Dec 18, 8PM SGT'
    },
    9: {
      snapshotTime: 'Jan 20, 8PM SGT',
      claimingPeriod: 'Jan 22, 8PM SGT - Mar 22, 8PM SGT'
    }
  } as Record<number, { snapshotTime: string; claimingPeriod: string }>
} as const;

export type CedefiRound = (typeof CEDEFI_ROUNDS.ALL_ROUNDS)[number];

export const getRoundTimes = (
  round: number
): { snapshotTime: string; claimingPeriod: string } => {
  const roundTime = CEDEFI_ROUNDS.ROUND_TIMES[round];
  if (roundTime) {
    return roundTime;
  }
  return CEDEFI_ROUNDS.ROUND_TIMES[CEDEFI_ROUNDS.LATEST_ROUND]!;
};
